import React, { useState } from "react";
import { ContentManager } from "@/admin/ContentManager";
import SiteSettings from "@/admin/SiteSettings";

const SUBTABS = [
  { id: "settings", name: "Homepage & Contact" },
  { id: "events", name: "Events" },
  { id: "programs", name: "Programs" },
  { id: "posts", name: "Success Stories" },
  { id: "partners", name: "Partners / Sponsors" },
  { id: "board", name: "Board Members" },
];

const EVENT_FIELDS = [
  { key: "title", label: "Event Title", placeholder: "SHE BELIEVES Confidence Circle" },
  { key: "date_label", label: "Date", placeholder: "Saturday, Jan 24, 2026" },
  { key: "time_label", label: "Time", placeholder: "10:00 AM - 1:00 PM" },
  { key: "location", label: "Location", placeholder: "Charlotte Public Library" },
  { key: "description", label: "Description", type: "textarea" },
  { key: "image", label: "Image (optional)", type: "image" },
];

const PROGRAM_FIELDS = [
  { key: "tag", label: "Tag", placeholder: "SHE BELIEVES" },
  { key: "title", label: "Title", placeholder: "Confidence Development" },
  { key: "description", label: "Description", type: "textarea" },
  { key: "topics", label: "Topics (comma-separated)", full: true, placeholder: "Self-worth, Public Speaking" },
  { key: "cta_label", label: "Button Label", placeholder: "Inquire for School" },
  { key: "cta_link", label: "Button Link", placeholder: "/contact" },
  { key: "image", label: "Image (optional)", type: "image" },
];

const POST_FIELDS = [
  { key: "title", label: "Title", placeholder: "How AGG changed my daughter's life" },
  { key: "author", label: "Author", placeholder: "Parent of a SHE BELIEVES participant" },
  { key: "excerpt", label: "Short Excerpt", type: "textarea" },
  { key: "body", label: "Full Story", type: "textarea" },
  { key: "image", label: "Photo", type: "image" },
];

const PARTNER_FIELDS = [
  { key: "name", label: "Partner / Sponsor Name", placeholder: "Charlotte-Mecklenburg Schools" },
  { key: "description", label: "Description", type: "textarea" },
  { key: "url", label: "Website Link (optional)", placeholder: "https://…" },
  { key: "logo", label: "Logo / Image", type: "image" },
];

const BOARD_FIELDS = [
  { key: "name", label: "Name", placeholder: "Cherelle Hawkins-Frazier" },
  { key: "role", label: "Role / Title", placeholder: "Founder & President" },
  { key: "bio", label: "Bio", type: "textarea" },
  { key: "image", label: "Headshot", type: "image" },
];

const WebsiteContent = () => {
  const [tab, setTab] = useState("settings");

  return (
    <div className="bg-white border border-[#E5E5E5]/50 rounded-2xl p-6 md:p-8 space-y-6" data-testid="panel-content">
      <div>
        <h3 className="font-serif text-xl font-bold text-[#4B1E5A]">Website Content</h3>
        <p className="font-sans text-sm text-[#4A4A4A]">Add, edit, publish, unpublish, reorder, and upload images — no code required. Only published items appear on the live site.</p>
      </div>

      <div className="flex overflow-x-auto gap-2 border-b border-[#FFF5F9] pb-3 font-sans text-xs">
        {SUBTABS.map((s) => (
          <button key={s.id} onClick={() => setTab(s.id)} data-testid={`content-subtab-${s.id}`} className={`px-3.5 py-2 rounded-full font-semibold whitespace-nowrap transition-all ${tab === s.id ? "bg-[#4B1E5A] text-white" : "bg-[#FFF5F9] text-[#4A4A4A] hover:bg-[#FFE5F1]"}`}>
            {s.name}
          </button>
        ))}
      </div>

      {tab === "settings" && <SiteSettings />}
      {tab === "events" && <ContentManager title="Events" description="Manage upcoming experiences shown on the Events page." ctype="events" fields={EVENT_FIELDS} />}
      {tab === "programs" && <ContentManager title="Programs" description="Signature program pillars." ctype="programs" fields={PROGRAM_FIELDS} />}
      {tab === "posts" && <ContentManager title="Success Stories" description="Blog posts & success stories." ctype="posts" fields={POST_FIELDS} />}
      {tab === "partners" && <ContentManager title="Partners / Sponsors" description="Organizations and sponsors." ctype="partners" fields={PARTNER_FIELDS} />}
      {tab === "board" && <ContentManager title="Board Members" description="Leadership & board." ctype="board" fields={BOARD_FIELDS} />}
    </div>
  );
};

export default WebsiteContent;
